module.exports = __webpack_public_path__ + "static/media/Silder2.d32dd822.png";